import React, { FC } from 'react';
import _ from 'lodash';
import { Box } from '@wix/design-system';
import StudioBadgeSvg from '@components/Images/StudioBadgeSvg';
import s from './CarouselStudioBranding.module.scss';

interface Props {
  isMobileView?: boolean;
}

const CarouselStudioBranding: FC<Props> = ({ isMobileView }) => {
  return (
    <Box
      className={s.logoBackground}
      position="absolute"
      right="8px"
      bottom="8px"
    >
      <StudioBadgeSvg />
    </Box>
  );
};

export default CarouselStudioBranding;
